import React, { useContext, useEffect, useState } from "react";
import IRoute from "../../../models/IRoute";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import { useFormik } from "formik";
import INewRoute from "../../../models/INewRoute";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwButton from "../../shared/OwButton/OwButton";
import IProcessRouteDTO from "../../../models/DTO/IProcessRouteDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnProcessRouteDTO from "../../../models/DTO/IOnProcessRouteDTO";
import UiContext from "../../../contexts/UiContext";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";

type Props = {
    route?: IRoute;
    cancelFn: (refresh?: boolean) => void;
};

export const RouteSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [route, setRoute] = useState<IRoute | INewRoute | undefined>(props.route);
    const [isDisabled, setIsDisabled] = useState(true);

    const cancel = () => {
        props.cancelFn();
    };

    const processRoute = (values: { name: string; is_pickup: boolean }) => {
        const payload: IProcessRouteDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            route: {
                name: values.name,
                is_pickup: values.is_pickup,
                guid: props.route ? props.route.guid : undefined,
            },
        };

        socket.emit(EndpointsEnum.RoutesProcessRoute, payload);
    };

    const onProcessRoute = (data: IOnProcessRouteDTO) => {
        const notification: INotification = {
            message: "successfully_processed_route",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        props.cancelFn(true);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.RoutesOnProcessRoute, fn: onProcessRoute }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const formik = useFormik({
        initialValues: {
            name: route?.name || "",
            is_pickup: route?.is_pickup || false,
        },
        onSubmit: (values) => {
            // props.getTransportOptions(values);
            processRoute(values);
        },
        validate: (values) => {
            const errors: any = {};

            if (!values.name) {
                errors.name = "Required";
            }

            setIsDisabled(Object.keys(errors).length > 0);

            return errors;
        },
    });

    return (
        <div className={"RouteSidebar p-2"}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <div className="text-end">
                        <button className="btn btn-danger btn-sm" onClick={cancel}>
                            <i className="far fa-times" />
                        </button>
                    </div>
                    <OwTitle className={"mb-2"} leftIconName={"fad fa-road"} title={"route"} />
                    <hr />
                </div>
            </div>

            <div className="row mt-2">
                <form onSubmit={formik.handleSubmit}>
                    <div className={"d-flex flex-column mb-4"}>
                        <div>
                            <OwLabel title={"name"} isBold={true} />
                        </div>
                        <div className={""}>
                            <OwFnInput
                                className={"form-control form-control-sm"}
                                fn={formik.handleChange}
                                name={"name"}
                                value={formik.values.name}
                            />
                        </div>
                    </div>

                    <div className={"d-flex flex-column mb-4"}>
                        <div>
                            <OwCheckbox
                                name={"is_pickup"}
                                fn={formik.handleChange}
                                checked={formik.values.is_pickup}
                                label={"is_pickup"}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                    </div>

                    <div>
                        <OwButton type={"submit"} title={"save"} disableOnActive={true} disabled={isDisabled} />
                    </div>
                </form>
            </div>
        </div>
    );
};
